import React, { useRef } from "react";

var useFocus = function useFocus() {
  var htmlRef = useRef(null);

  var setFocus = function setFocus() {
    htmlRef.current && htmlRef.current.focus();
  };

  return [htmlRef, setFocus];
};

export default useFocus;